<template>
    <button 
    :class="{
        'dark' : theme == 'dark', 
        'light' : theme == 'light',
        'green' : theme == 'green',
        'yellow' : theme == 'yellow',
        'primary_colour' : theme == 'primary_colour',
        'disabled' : disabled == true,
        'reduced-opacity' : reduced_opacity == true,
        'wide-letter-spacing': wide_letter_spacing == true,
        'no-border': has_border == false
    }" 
    class='button' type="button" v-html="text" :id='id'></button>
</template>

<script>

export default {
    props: {
        id: {},
        text:{},
        theme: {
            default: 'dark',
        },
        disabled: {},
        reduced_opacity: {},
        wide_letter_spacing:{},
        has_border: {default: true}
    }   
}
</script>

<style lang="scss" scoped>
.button{
    color: white;
    // text-transform: uppercase;
    padding: 16px 30px;
    font-weight: 400;
    text-align: center;
    border-radius: 24px;
    cursor: pointer;
    width: 100%;
    border: none;
    // height: 36px;
}

.button.dark{
    background-color: var(--black);
}

.button.green{
    background-color: var(--primary-colour);
}

.button.primary_colour{
    background-color: var(--primary-colour);
    color: white;
}

.button.light{
    background-color: white;
    font-weight: 100;
    color: var(--black);
    outline: solid 1px var(--black);
    // border: solid 2px var(--black);
}


.button.disabled{
    opacity: 0.3;
    cursor: default;
}

.button.reduced-opacity{
    opacity: 0.7;
}

.wide-letter-spacing{
    letter-spacing: 1.4px;
}

.no-border{
    border: none !important;
}

</style>